import { render, staticRenderFns } from "./MediaSiputra.vue?vue&type=template&id=1613989a&"
import script from "./MediaSiputra.vue?vue&type=script&lang=js&"
export * from "./MediaSiputra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports